module.exports = __webpack_public_path__ + "static/media/3DPPA21.998064f8.jpg";